module.exports = __webpack_public_path__ + "static/icons/icon-map--greece-2f3474d5e889745d561e93f4cd8eff3a.svg";